// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"2b09d764","510":"1b5eaf7c"}[chunkId] + ".chunk.js";
};